import Detail from './Detail'
// import Form from './Form'

const EspacesAnnexes = {
  Detail,
  // Form
}

export default EspacesAnnexes